import VerifyEmailForm from "../components/verify";

const VerifyPage = () => {
  return <VerifyEmailForm />;
};

export default VerifyPage;
